import { SectorModel } from './../service/sector.model';
import { DropzoneComponent, DropzoneConfigInterface, DROPZONE_CONFIG, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subscription, interval } from 'rxjs';
import { DBConnectorService } from './../service/test.service';
import { PredictService } from './../service/predict.service';
import { Router } from '@angular/router';
// import { DialogService } from 'ng2-bootstrap-modal';
import { ShowLogDialogComponent } from '../show-log-dialog/show-log-dialog.component';

import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-predict',
  templateUrl: './predict.component.html',
  styleUrls: ['./predict.component.css']
})

export class PredictComponent implements OnInit, OnDestroy {

  predictDesc: string;
  bsModalRef: BsModalRef;
  enableGetLogs: boolean;
  enableGetLogsexcel: boolean;
  @ViewChild(DropzoneDirective) directiveRef: DropzoneDirective;
  FileUploaded = false;
  // click= true;
  predictclick = false;
  sub: Subscription;
  Modelsub: Subscription;
  result:any = {};
  Instaresult:any = {};
  Status = "";
  Description = {
    "Sector": null,
    "Model": null,
    "Desc": "",
    "User": ""
  };
  isDiabled=false;

  sectormodel = new SectorModel;
  public IsContraEnabled: boolean;
  public showContraCheckBox: boolean;

  public config: DropzoneConfigInterface = {
    url: "/api/PredictUsingExcel/SaveUploadedPredictedFile",
    clickable: true,
    headers: {
      'Sector': this.sectorservice.SectorName,
      'Model': this.sectorservice.ModelName,
      'User': this.sectorservice.username
    },
    uploadMultiple: false,
    autoReset: null,
    errorReset: 15000,
    cancelReset: 15000,
    maxFiles: 1,
    createImageThumbnails: true,
    dictDefaultMessage: "Drag and Drop or Click to browse for files",
    acceptedFiles: ".xlsm",
    timeout: 240000
  };

  constructor(private sectorservice: DBConnectorService,
    private predictservice: PredictService,
    private http: HttpClient,
    private router: Router,
    private _dialogService: BsModalService
    ) {

    this.sectormodel.SectorName = this.sectorservice.SectorName;
    this.sectormodel.ModelName = this.sectorservice.ModelName;
    this.sectorservice.onGetSec.subscribe((res) => { this.sectormodel.SectorName = res });
    this.Modelsub = this.sectorservice.onGetMod.subscribe((res) => {
      this.sectormodel.ModelName = res;
      this.configset();
      this.PredictStatus();
      this.predictclick = false;
    });
    
    this.IsContraVisible();
  }

  // onclick2(){
  //   this.click= true;
  // }
  configset() {
    let url1 = "/api/PredictUsingExcel/SaveUploadedPredictedFile";
    // var resource = this.adalService.GetResourceForEndpoint(url1);
    // let token = this.adalService.getCachedToken(resource);
    // let tokenbearer = 'Bearer ' + token;

    this.config = {
      url: url1,
      clickable: true,
      headers: {
        'Authorization': this.sectorservice.getToken(url1),
        'Sector': this.sectorservice.SectorName,
        'Model': this.sectorservice.ModelName,
        'User': this.sectorservice.username
      },
      uploadMultiple: false,
      autoReset: null,
      errorReset: 15000,
      cancelReset: 15000,
      maxFiles: 1,
      createImageThumbnails: true,
      dictDefaultMessage: "Drag and Drop or Click to browse for files",
      acceptedFiles: ".xlsm",
      addRemoveLinks: true,
      timeout: 240000
    };
  }

  onUploadError(args: any) {
    // console.log('onUploadError:', args);
  }
  onUploadSuccess(args: any) {
    // console.log('onUploadSuccess:', args);
    this.result = args[1];
  }

  onInstant() {
    this.enableGetLogs = true;
    if (this.sectormodel.SectorName != null && this.sectormodel.SectorName != "null") {
      this.isDiabled=true;
      this.Instaresult = {};
      // this.click= false;
      this.Description.Sector = this.sectorservice.SectorName;
      this.Description.Model = this.sectorservice.ModelName;
      this.Description.User = this.sectorservice.username;
      this.Description.Desc = this.predictDesc;

      console.log("Instant Predict - start");
      console.log(this.Description);
      this.predictservice.Insta(this.Description)
        .subscribe(
          (data) => {
          this.Instaresult = data;
            this.predictservice.setInsta(this.Instaresult);
            console.log(this.Instaresult);
            console.log("Instant predict - after api");
            this.isDiabled=false;
            if (this.Instaresult["InstantError"] == null) {
              this.router.navigate(['Predict/InstantPredict']);
            }
          },
          (error) => console.log(error)
        );
    }
    else {
      this.Instaresult["InstantError"] = "Sector and Model have not been selected!";
    }

  }

  onpredict() {
    var Iscontra = this.IsContraEnabled;
    this.enableGetLogsexcel = true;
    if (this.sectormodel.SectorName != null && this.sectormodel.SectorName != "null") {
      this.result = {};
      this.predictclick = true;
      console.log("Predict - start");
      //console.log(this.sectormodel);
      this.predictservice.Predict(this.sectormodel, Iscontra)
        .subscribe(
          (data) => {
            this.result = data;
            this.predictservice.result = data;
            console.log(this.result);
            console.log("Predict - after api");
            this.predictclick = false;

            //to hide Detect Contra entries on predict tab for prediction using excel
            this.IsContraVisible();

            if (this.result["Desc"] == null && this.result["PredictError"] == null) {
              this.router.navigate(['Predict/PredictUsingExcel']);
            }
          },
          (error) => console.log(error));
    } else {
      this.result["PredictError"] = "Sector and Model have not been selected!";
    }

  }

  DownloadPredict() {
    if (this.sectormodel.SectorName != null && this.sectormodel.SectorName != "null") {
      this.result = {};
      let options: object = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        responseType: 'Blob',
        observe: 'response'
      }
      let url = "/api/Download/DownloadPredict" + "?Sector=" + this.sectorservice.SectorName + "&Model=" + this.sectorservice.ModelName + "&User=" + this.sectorservice.username;
      this.http.post<any>(url, '', options)
        .subscribe((res) => {
          let parsedResponse = res.body;
          var contentType = 'application/octet-stream';
          let blob = new Blob([parsedResponse], { type: contentType });
          let url = window.URL.createObjectURL(blob);
          // window.open(url);
          let contentDispositionHeader = res.headers.get("content-disposition");
          let filename = contentDispositionHeader.split('=')[1].trim();

          let a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);


        }
        );
    } else {
      this.result["PredictError"] = "Sector and Model have not been selected!";
    }
  }
  //FileUpload
  fileChange(event: any) {

    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      alert("Uploading Files");
      this.FileUploaded = true;
      console.log(fileList)
      let formData: FormData = new FormData();
      for (var i in fileList) {
        let file: File = fileList[i];
        formData.append('uploadFile', file, file.name);
        //console.log(formData);
      }

      let options = {
        headers: new HttpHeaders({
          'Accept': 'application/json',
          'Sector': this.sectorservice.SectorName,
          'Model': this.sectorservice.ModelName,
          'User': this.sectorservice.username
        })
      }

      // Passing arguments as URLSearchparameters
      // let parameters: URLSearchParams = new URLSearchParams();
      // parameters.append('Sector', this.sectorservice.SectorName);
      // parameters.append('Model', this.sectorservice.ModelName);
      // // parameters.append('User', this.adalService.userInfo.userName);
      // parameters.append('User', this.sectorservice.username);
      // options.params = parameters;

      let apiUrl = "/api/PredictUsingExcel/SaveUploadedPredictedFile";
      //console.log(apiUrl);
      this.http.post<any>(apiUrl, formData, options)
        //.catch(error => Observable.throw(error))
        .subscribe(
          (data) => {
            console.log(data);
            this.result = data;
            alert("Files Uploaded");
          }
          //error => console.log("error");

        )
    }
  };

  CancelPredict() {
    this.sectormodel.User = this.sectorservice.username;
    this.predictservice.cancelPredict(this.sectormodel)
      .subscribe(
        (data) => { });
  }

  PredictStatus() {
    if (this.sectormodel.SectorName != null && this.sectormodel.SectorName != "null") {
      this.result = {};
      this.sectormodel.User = this.sectorservice.username;
      this.predictservice.statusCheck(this.sectormodel)
        .subscribe(
          (data) => {
            this.Status = data;
            if (this.Status == "ACTIVE") {
              this.predictclick = true;
              // this.enableGetLogs = true;
              this.enableGetLogsexcel = true;
            }
            else if (this.Status == "SUCCESS" && this.predictclick == true) {
              this.router.navigate(['Predict/PredictUsingExcel']);
            }
            else if (this.Status == "SUCCESS") {
              this.result["Desc"] = null;
              if (data != 'Error' && this.predictclick == true)
                this.result["Success"] = "Last Process Status:: " + data;
              else
                this.result["Success"] = null;
            }
            else {
              this.predictclick = false;
              this.result["Success"] = null;
              this.result["Desc"] = null;
            }
            console.log(this.Status);
          });
    } else {
      this.result["PredictError"] = "Sector and Model have not been selected!";
    }
  }

  IsContraVisible() {

    this.predictservice.contraStatusCheck(this.sectormodel)
      // .subscribe(
      //   (data) => {
      //     var dataSectroData = data;
      //     //this.showContraCheckBox = data;
      //   });

  }

  ngOnInit() {
    this.configset();
    this.PredictStatus();

    this.sub = interval(5000).subscribe(x => {
      if (this.predictclick == true) {
        this.PredictStatus();
      }
    });
  }
  ngOnDestroy() {
    if (this.sub != null) {
      this.sub.unsubscribe();
    }
    if (this.Modelsub != null) {
      this.Modelsub.unsubscribe();
    }
  }

  OpenLogsDialog() {
    console.log("OpenLogsDialog clicked!")
    const initialState = {
      source: "predict",
      username: this.sectorservice.username
    };
    this.bsModalRef = this._dialogService.show(ShowLogDialogComponent, { initialState })
    //this._dialogService.addDialog(ShowLogDialogComponent, { source: "predict", username: this.sectorservice.username }).subscribe(data => console.log(data))
  }

  OpenExcelLogsDialog() {
    console.log("OpenExcelLogsDialog clicked!")
    const initialState = {
      source: "excel_predict",
      username: this.sectorservice.username
    };
    this.bsModalRef = this._dialogService.show(ShowLogDialogComponent, { initialState })
    //this._dialogService.addDialog(ShowLogDialogComponent, { source: "excel_predict", username: this.sectorservice.username }).subscribe(data => console.log(data))
  }

}
